import { authProtectedRoutes } from "../../../../../Routes/allRoutes";

/**
 * Build the list of internal destinations a menu item can link to, derived from
 * the app's real route table. Parameterised routes (e.g. `/tasks/:id`) and
 * wildcards are skipped because they aren't valid as a static menu target.
 *
 * Stored value has NO leading slash to match the existing convention (the
 * sidebar renderer prepends it) — see the note in the legacy menu builder.
 */
let cached = null;

export function getRouteOptions() {
  if (cached) return cached;

  const seen = new Set();
  const options = [];

  for (const route of authProtectedRoutes || []) {
    const path = route?.path;
    if (!path || typeof path !== "string") continue;
    if (path.includes(":")) continue; // skip param routes
    if (path.includes("*")) continue; // skip wildcards

    const value = path.replace(/^\//, "");
    if (!value || seen.has(value)) continue;
    seen.add(value);
    options.push({ value, label: value });
  }

  cached = options.sort((a, b) => a.label.localeCompare(b.label));
  return cached;
}

/** Normalise a freeform/selected url into stored form (no leading slash). */
export function normaliseUrl(url) {
  if (!url) return "";
  return String(url).trim().replace(/^\//, "");
}
